import ISelection from "../interfaces/ISelection";

export default function convertSelectionsToNumbers(selections: ISelection[]): number[] {
    const numbers: number[] = [];

    const BASE_10 = 10;

    selections.forEach((sel: ISelection) => {
        if (sel.outcome) {
            const value = parseInt(sel.outcome.name, BASE_10);
            if (!isNaN(value)) {
                numbers.push(value);
            }
        }
    });

    return numbers;
}



// WEBPACK FOOTER //
// ./src/utils/convertSelectionsToNumbers.ts